export default "__VITE_ASSET__5a376433__$_?component__"